import { SBImage } from '@/components/ImageService/SBImage';
import { Typography } from '@/shared';
import { ProjectsStoryblok } from '@/shared/types/storyblok/storyblok-types';
import Link from 'next/link';
import styles from './FeaturedProject.module.scss';

const FeaturedProject = ({ featuredProject }: { featuredProject: ProjectsStoryblok }) => {
    const { customTitle, mainImage, component } = featuredProject?.content || {};
    let formattedTitle = customTitle?.replace(/\*/g, '') ?? '';
    formattedTitle = formattedTitle?.replace('&shy;', '');

    const getGroup = (string: string) => {
        let text = string;
        if (text?.endsWith('s')) {
            text = text?.substring(0, text.length - 1) || '';
        }
        text = text?.charAt(0).toUpperCase() + text?.slice(1);
        return text;
    };
    return (
        <div className={styles.projectBox}>
            <Link
                scroll={true}
                className={styles.link}
                href={featuredProject.full_slug}
            >
                {mainImage?.filename && (
                    <SBImage image={mainImage} height={256} fit="cover" className={styles.projectImage} />
                )}
                <div className={styles.infoStyle}>
                    <span className={styles.name}>{getGroup(component)}</span>
                    {component && featuredProject?.name && <span>·</span>}
                    <span className={styles.role}>{featuredProject?.name}</span>
                </div>
                <div>
                    <Typography.ArticleQuote className={styles.title}>{formattedTitle}</Typography.ArticleQuote>
                </div>
            </Link>
        </div>
    );
};

export default FeaturedProject;
